<!--工作室成果-->
<template>
    <div class="studio_nav_content">
        <div class="left-container">
            <div class="nav-container">
                <div class="nav-title">
                    教师文章
                </div>
                <div class="nav-list">
                    <div class="type-active" @click="cleanClassify">>教师文章</div>
                    <!--文章类目-->
                    <div :class="itemKey===item.dictKey?'menu-item is-active':'menu-item'" @click="changeInfoClassify(item)" v-for="item in studioClassifyList" :key="item">
                        {{item.dictValue}}
                    </div>

                </div>
            </div>
        </div>

        <div class="right-container">
            <div class="page-info-container" v-show="showMode==='page'">
                <div class="info-top-title">
                    <div class="title">{{itemName}}</div>
                </div>
                <div class="info-list-container">
                    <div class="info-container" v-if="dataList&&dataList.length>0">
                        <div class="info-item" v-for="item in dataList" :key="item">
                            <div class="info-name" @click="viewInfo(item)">{{item.title}}</div>
                            <div class="info-user">{{item.trueName}}</div>
                            <div class="info-time">{{ timestampDate(item.createTime) }}</div>
                        </div>
                    </div>
                    <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                </div>
                <div class="page-container" v-if="dataList&&dataList.length>0">
                    <pageTag :background="true"
                             :pageSizes="[10, 20, 30]"
                             v-show="total > 0"
                             :total="total"
                             v-model:page.sync="queryParams.pageNum"
                             v-model:limit.sync="queryParams.pageSize"
                             @pagination="pageAchievement" />
                </div>
            </div>

            <!--详情模式 -->
            <div class="page-info-container"  v-show="showMode==='detail'">
                <view-info :info-id="this.infoId" :info-title="this.detailName"/>
            </div>
        </div>
    </div>
</template>

<script>
import {studioQueryClassify,pageStudioInfo} from "@/api/admin/studio";
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampDate} from "@/utils/date";
import viewInfo from "@/components/studioDetail/viewInfo.vue";

export default {
    name:'noticeNews',
    components:{viewInfo, pageTag, dataEmpty},
    props:{
        studioId:{
            type: String,
            default:null
        },
        achieveMode:{
            type: String,
            default:'page'
        },
        parentId:{
            type: String,
            default:''
        }
    },
    watch:{
        achieveMode(newValue,oldValue){
            this.showMode = newValue;
        },
        parentId(newValue,oldValue){
            this.infoId = newValue;
        },
    },
    mounted() {
        this.queryClassify();
        this.pageAchievement()
    },
    data() {
        return {
            showMode:'page',
            timestampDate,
            itemName:'教师文章',
            detailName:'',
            itemKey:'',
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                type:2,
                groupId:'',
                classify:'',
            },
            total: 0,
            pageCount:0,
            dataList: [],
            studioClassifyList:[],
            infoId:'',
        }
    },
    methods: {
        queryClassify() {
            studioQueryClassify({ code: 'studio_info_type_2',belong: this.studioId }).then(res => {
                this.studioClassifyList = res.data.data;
            })
        },
        changeInfoClassify(item){
            this.queryParams.classify = item.dictKey;
            this.itemKey = item.dictKey;
            this.pageAchievement();
        },
        cleanClassify(){
            this.queryParams.classify = '';
            this.itemKey = '';
            this.pageAchievement();
        },
        pageAchievement(){
            this.queryClassify();
            this.queryParams.groupId = this.studioId;
            pageStudioInfo(this.queryParams).then(res=>{
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                    this.showMode = 'page';
                    this.$emit('change-mode',this.showMode, 4);
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        viewInfo(item){
            this.showMode = "detail"
            this.detailName = '文章详情'
            this.infoId = item.infoId;
            this.$emit('change-mode',this.showMode, 4);
        }
    }
}

</script>

<style scoped>
.studio_nav_content{
    display: flex;
    width: 100%;
    height: auto;
}
.left-container{
    width: 200px;
    height: auto;
    padding-bottom: 20px;
    box-sizing: border-box;
}
.nav-container{
    width: 180px;
    height: 120px;
    background: #fff;
}
.nav-title{
    width: 100%;
    height: 36px;
    background-color: #3b62f8;
    color: #fff;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    margin-bottom: 10px;
}
.nav-list{
    width: 180px;
    height: auto;
    background: #fff;
    padding-bottom: 10px;
}
.type-active{
    width: 100%;
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    color: #3b62f8;
    font-weight: bold;
}
.menu-item{
    width: 100%;
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    color: #333333;
    font-family: "Microsoft JhengHei",sans-serif;
    font-weight: bold;
}
.is-active{
    color: #3b62f8!important;
}

.right-container{
    width: calc(100% - 200px);
    height: auto;
}
.page-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
}
.info-top-title{
    width: 99%;
    height: 34px;
    margin: auto;
    line-height: 34px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    flex-direction: column;
}
.title{
    padding-right: 10px;
    border-bottom: 2px solid #3b62f8;
}

.info-list-container{
    width: 100%;
    height: auto;
    margin: auto;
    overflow-x: hidden;
}
.info-container{
    width: 98%;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
}
.info-item{
    display: flex;
    width: 100%;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    border-bottom: 1px dashed #cecece;
}
.info-name{
    width: calc(100% - 180px);
    color: #717171;
    text-align: left;
    font-size: 16px;
    cursor: pointer;
}
.info-name:hover{
    color: #3b62f8;
}
.info-user{
    width: 80px;
    color: #3b62f8;
    text-align: center;
    font-size: 15px;
}
.info-time{
    width: 100px;
    color: #717171;
    text-align: right;
    font-size: 15px;
    padding-right: 10px;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    margin-top: 10px;
}
</style>